import { environment } from "environment";

export const CHECKOUT_API = {
  createOrder: `/order/makeOrderByCart`,
  calculateOrderCost: `/order/calculate-cost`,
  getProductsPricing: `${environment.BACKEND_URL}admin/orders/product-prices`,
};
